module.exports = __webpack_public_path__ + "static/media/logo-home.4b5dd6e5.png";